import { render, staticRenderFns } from "./Vue2BootstrapModal.vue?vue&type=template&id=73d60a72&scoped=true"
import script from "./Vue2BootstrapModal.vue?vue&type=script&lang=js"
export * from "./Vue2BootstrapModal.vue?vue&type=script&lang=js"
import style0 from "./Vue2BootstrapModal.vue?vue&type=style&index=0&id=73d60a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d60a72",
  null
  
)

export default component.exports